import React from 'react';
import StripedTableEmptyRow from './StripedTableEmptyRow';

const StripedTableEmptyRows = ({
    border,
    scrollPx = 0,
    startingIndex = 0,
    endingIndex = 16,
    columns = 1,
    height = 40,
    firstRowIndex = 1,
    ...props
}) => {
    const retVal = [];
    for (let i = startingIndex; i <= endingIndex; i++) {
        retVal.push(
            <StripedTableEmptyRow
                {...props}
                key={i}
                columns={columns}
                row={i}
                cellStyle={{
                    bottom: scrollPx,
                    ...props.style
                }}
                border={border}
                height={height}
                isFirstRow={firstRowIndex === i}
            />
        );
    }
    return retVal;
};

export default StripedTableEmptyRows;
